package com.essntl.features.organization.ui

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.file.ui.FileState
import com.essntl.features.organization.domain.model.OrganizationModel

data class OrganizationState(
    val getAllOrganizations: PaginationState<OrganizationModel> = PaginationState(),
    val fileState: FileState = FileState(),
    val organization: MutableState<OrganizationModel> = mutableStateOf(OrganizationModel.empty),
    val addAddress: Boolean = false,
    val uploadLogo: State<Unit> = State(),
    var selectedParentOrganization: MutableState<OrganizationModel> = mutableStateOf(OrganizationModel.empty),
)